"use client";

import { useEffect } from "react";
import { usePostHog } from "@posthog/next";
import {
  INTERNAL_SUPER_PROPERTY,
  syncInternalFlagFromUrl,
} from "@/lib/internal-traffic";

/**
 * Tags every event from a tester's browser with the `is_internal` super
 * property so anonymous testing can be excluded from analytics via the
 * project's test-account filters. Toggled with the `?internal=1` / `?internal=0`
 * URL param (see lib/internal-traffic).
 */
export function InternalTrafficTag() {
  const posthog = usePostHog();

  useEffect(() => {
    if (!posthog) return;
    const search =
      typeof window !== "undefined" ? window.location.search : "";
    if (syncInternalFlagFromUrl(search)) {
      posthog.register({ [INTERNAL_SUPER_PROPERTY]: true });
    } else {
      posthog.unregister(INTERNAL_SUPER_PROPERTY);
    }
  }, [posthog]);

  return null;
}
